import { render, staticRenderFns } from "./Tutoriais.vue?vue&type=template&id=d53024b8&scoped=true&"
import script from "./Tutoriais.vue?vue&type=script&lang=js&"
export * from "./Tutoriais.vue?vue&type=script&lang=js&"
import style0 from "./Tutoriais.vue?vue&type=style&index=0&id=d53024b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53024b8",
  null
  
)

export default component.exports